<template>
  <div>
    <div class="landing-header" id="inicio">
     <!--  <div class="triangle">
        <v-img src="@/assets/img/backgrounds/tringle-header.svg" />
      </div> -->
      <div class="header_title">
        <h1>ObiPets</h1>
        <p>Protege a tu mascota</p>
      </div>
      <v-col>
        <v-row justify="center" align="center">
          <v-icon class="spin" color="#A7C84B" style="font-size:120px;">mdi-reload</v-icon>
        </v-row>
      </v-col>
      <!-- <div class="placas_header">
        <div style="transform: rotate(-25deg); margin-left:500px;">
          <v-img contain src="@/assets/img/instructions/placanoname.svg"></v-img>
        </div>
        <div style="transform: rotate(25deg); margin-right:500px;">
          <v-img contain src="@/assets/img/instructions/placacode.svg"></v-img>
        </div>
      </div>-->
      <div class="text-center mb-8">
       <!--  <v-btn
          href="https://obipets.myshopify.com/products/placa-obipets"
          target="new"
          x-large
          color="#A7C84B"
          style="font-family: 'Kaleko', sans-serif; font-size:20px; text-transform:none;"
          dark
          >Comprar</v-btn
        > -->
      </div>
    </div>
    <v-btn
      v-scroll="onScroll"
      v-show="fab"
      fab
      dark
      fixed
      bottom
      right
      color="indigo"
      @click="toTop"
    >
      <v-icon>mdi-chevron-up-circle</v-icon>
    </v-btn>
    <div style="height:15px; width:100%" id="comofunciona"></div>
    <div class="landing-content">
      <div class="landing-content-one mt-5 mb-5 text-center container">
        <h2 class="landing-title">¿Cómo funciona?</h2>
        <p class="mb-8 mt-8">
          Podrás recibir la ubicación de tu mascota en caso de extravío.
        </p>
        <v-img contain src="@/assets/img/instructions/dog_located.png" />
        <p class="mb-8 mt-8">
          Al escanear el código QR de la placa, obtendrán información tuya y de
          tu mascota.
        </p>
        <v-container>
          <v-row>
            <v-img
              class
              height="400"
              contain
              src="@/assets/img/instructions/pet_profile-01.png"
            />
          </v-row>
        </v-container>
        <p class="mb-8 mt-8">
          Quien encontró a tu mascota podrá ponerse en contacto contigo mediante
          SMS, correo electónico o WhatsApp.
        </p>
        <v-img
          contain
          height="400"
          src="@/assets/img/instructions/send_message.png"
        />
        <v-img
          contain
          height="400"
          src="@/assets/img/instructions/enty_message.png"
        />
        <p class="mb-8 mt-8">
          La Placa Inteligente ObiPets puede ser escaneada con cualquier móvil.
        </p>
        <v-img
          contain
          height="400"
          src="@/assets/img/instructions/gato-01.png"
        />
      </div>
      <div id="instrucciones" class="mx-5" style="height:50px"></div>
      <v-container class="mb-10">
        <v-row>
          <v-col class="text-center ins mx-5">
            <h1>Instrucciones</h1>
          </v-col>
        </v-row>
      </v-container>
      <div class="landing-content-tow">
        <h2 class="landing-title">
          1.-Ingresa a ObiPets.com.mx e inicia sesión o crea una cuenta.
        </h2>

        <div class="image-two">
          <div class="onedotone">
            <v-img src="@/assets/img/instructions/REGISTRO 1.1.png" />
          </div>
          <div class="one">
            <v-img src="@/assets/img/instructions/REGISTRO 1.png" />
          </div>
        </div>
      </div>
      <div class="paso2">
        <h2 class="landing-title">2.-Llena tus datos de dueño.</h2>

        <v-img
          class="two"
          contain
          src="@/assets/img/instructions/REGISTRO 2.png"
          alt="step2"
        ></v-img>
      </div>
      <div class="landing-content-imgL">
        <h2 class="landing-title ml-5 mb-5">3.-Agrega una mascota.</h2>
        <v-img
          class="three"
          contain
          height="400"
          src="@/assets/img/instructions/REGISTRO 3.png"
        >
          <template v-slot:placeholder>
            <v-row class="ma-0" align="center" justify="center">
              <v-progress-circular
                indeterminate
                color="grey lighten-5"
              ></v-progress-circular>
            </v-row>
          </template>
        </v-img>
      </div>
      <div class="paso2">
        <h2 class="landing-title">4.-Registra los datos de tu mascota.</h2>
        <v-img
          class="four"
          contain
          src="@/assets/img/instructions/REGISTRO 4.png"
        />
      </div>
      <div class="landing-content-tow">
        <h2 class="landing-title mb-10">
          5.-Ingresa el código de activación que viene en el empaque y escanea
          el código QR de la placa.
        </h2>
        <div class="image-two">
          <div class="onedotone">
            <v-img src="@/assets/img/instructions/REGISTRO 5.png" contain />
          </div>
          <div class="one">
            <v-img
              style="margin-left: 80px;"
              contain
              src="@/assets/img/instructions/REGISTRO 5.1.png"
            />
          </div>
        </div>
        <div style="height:30px"></div>
      </div>
    </div>

    <div class="landing-footer">
      <div class="content">
        <h2>LISTO</h2>
        <p>
          Tu código queda activo, y cualquier persona que lo escanee tendrá
          acceso a tu información de contacto y a la de tu mascota.
        </p>
        <p>
          Podrás acceder a la ubicación donde fue escaneada tu mascota.
        </p>
        <p>
          *Ubicación disponible al aceptar compartir la ubicación*.
        </p>
        <div class>
          <p>ObiPets &trade;</p>
        </div>
      </div>
    </div>
    <div class="container text-center mt-5 mb-5 footer-footer" id="nosotros">
      <h2 class="mt-10">¿Quiénes somos?</h2>
      <p class="mt-10">
        Somos un grupo de amigos amantes del bienestar animal. Hemos rescatado
        animales en situación de calle o maltrato, los rehabilitamos física y
        emocionalmente, los esterilizamos, vacunamos y les buscamos un buen
        hogar donde sean amados y tratados como un integrante más de la familia.
      </p>
      <h3 class="mb-5">
        Con la compra de tu Placa Inteligente ObiPets ayudarás al rescate de más
        animalitos en situación de calle.
      </h3>
      <v-img class="perros" src="@/assets/perros.jpg" contain />

      <v-container>
        <h3>Siguenos</h3>
        <v-col>
          <a
            style="text-decoration:none;"
            href="https://www.facebook.com/ObiPets/"
            target="_blank"
          >
            <v-icon color="#A7C84B" class="mx-1">mdi-facebook</v-icon>
          </a>
          <a
            style="text-decoration:none;"
            href="https://www.instagram.com/obipets/"
            target="_blank"
          >
            <v-icon color="#A7C84B" class="mx-1">mdi-instagram</v-icon>
          </a>
          <a
            style="text-decoration:none;"
            href="https://wa.me/message/5XW7W2ZLGPAHP1"
            target="_blank"
          >
            <v-icon color="#A7C84B" class="mx-1">mdi-whatsapp</v-icon>
          </a>

          <a
            style="text-decoration:none;"
            href="https://www.youtube.com/channel/UCApVVqnvVjf81dXA9o5Woeg"
            target="_blank"
          >
            <v-icon color="#A7C84B" class="mx-1">mdi-youtube</v-icon>
          </a>

          <a
            style="text-decoration:none;"
            href="https://www.pinterest.com.mx/obipets/"
            target="_blank"
          >
            <v-icon color="#A7C84B" class="mx-1">mdi-pinterest</v-icon>
          </a>

          <a
            style="text-decoration:none;"
            href="https://t.me/ObiPets"
            target="_blank"
          >
            <v-icon color="#A7C84B" class="mx-1">mdi-telegram</v-icon>
          </a>
        </v-col>
        <a href="mailto:hola@obipets.com.mx" style="text-decoration:none;">
          <v-icon color="#A7C84B" class="mx-1">mdi-email</v-icon>
          <p style="color:#000;">hola@obipets.com.mx</p>
        </a>
        <router-link style="text-decoration:none;" to="/aviso-de-privacidad"
          >Aviso de Privacidad</router-link
        >
      </v-container>
      <p>
        © Todos los derechos reservados 2020, Queda prohibida la reproducción de
        estos contenidos sin autorización previa.
      </p>
      <a href="https://www.digimundo.com.mx/">
        Powered by Digimundo Technologies ©2020
      </a>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  mounted() {
    window.location.replace("https://obipets.myshopify.com/");
  },
  data() {
    return {
      alignment: "center",
      justify: "center",
      fab: false,
    };
  },
  methods: {
    onScroll(e) {
      if (typeof window === "undefined") return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.fab = top > 20;
    },
    toTop() {
      this.$vuetify.goTo(1);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../assets/scss/style";
.landing-header {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-size: cover;
  background-position: center center;
}
.ins {
  h1 {
    font-family: "Kaleko", sans-serif;
    letter-spacing: 1px;
    color: $main_green;
    font-weight: 300;
    font-size: 45px;
  }
}
.paso2 {
  background-image: url("../assets/img/backgrounds/fondoverde.png");
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: auto;
  .two {
    margin-bottom: -0px;
    margin-top: -50px;
    width: 370px;
    height: 370px;
    align-self: center;
    @media only screen and (min-width: 1200px) {
      margin-bottom: 0;
      margin-top: -40;
      width: 500px;
      height: 500px;
    }
  }
  .four {
    margin-bottom: -20px;
    margin-top: -50px;
    align-self: center;
    width: 370px;
    height: 370px;
    @media only screen and (min-width: 1200px) {
      margin-bottom: -25px;
      margin-top: -70px;
      width: 500px;
      height: 500px;
    }
  }
}

/* Loading icon animation */
.spin {
  display: inline-block;
  transform-origin: center center;
  animation: spin 1.2s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
